import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Menu, MenuButton, MenuList, MenuItem, MenuItemGroup, MenuItemDivider } from 'components/Menu';
import SectionEditorModal from 'screens/SectionEditorModal';
import PlaylistPickerModal from 'screens/PlaylistPickerModal';
import NewLinkModal from 'screens/NewLinkModal';
import AssetPickerModal from 'screens/AssetPickerModal';
import AssetEditor from 'screens/AssetEditor';
import { PlaylistLinkPermissionModal, getChildPlaylistPermissionStatus } from 'screens/PlaylistLinkPermissionModal';
import CircularReferenceInfoModal from 'screens/CircularReferenceInfoModal';
import useModalQueryParam from 'hooks/useModalQueryParam';
import { useAddPlaylistAssets, useAddPlaylistLinks } from 'actions/playlists';
import { getIsAssetEditableInHub, ASSET_READ } from 'utils/privileges';
import { getCanMembersContribute } from 'utils/privileges/getCanMembersContribute';
function AddContentMenu(_ref) {
  var _playlist$content;
  var playlist = _ref.playlist;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useParams = useParams(),
    parentPlaylistId = _useParams.id;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showOptionalModal = _useState2[0],
    setShowOptionalModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCircularReferenceModal = _useState4[0],
    setShowCircularReferenceModal = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    playlistsToAdd = _useState6[0],
    setPlaylistsToAdd = _useState6[1];
  var _useModalQueryParam = useModalQueryParam('add-asset'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasAssetPicker = _useModalQueryParam2[0],
    toggleAssetDialog = _useModalQueryParam2[1];
  var _useModalQueryParam3 = useModalQueryParam('add-section'),
    _useModalQueryParam4 = _slicedToArray(_useModalQueryParam3, 2),
    hasSectionDialog = _useModalQueryParam4[0],
    toggleSectionDialog = _useModalQueryParam4[1];
  var _useModalQueryParam5 = useModalQueryParam('add-playlist-link'),
    _useModalQueryParam6 = _slicedToArray(_useModalQueryParam5, 2),
    hasPlaylistLinkDialog = _useModalQueryParam6[0],
    togglePlaylistLinkDialog = _useModalQueryParam6[1];
  var _useModalQueryParam7 = useModalQueryParam('add-new-asset'),
    _useModalQueryParam8 = _slicedToArray(_useModalQueryParam7, 2),
    hasNewContentDialog = _useModalQueryParam8[0],
    toggleNewContentDialog = _useModalQueryParam8[1];
  var _useModalQueryParam9 = useModalQueryParam('add-weblink'),
    _useModalQueryParam10 = _slicedToArray(_useModalQueryParam9, 2),
    hasWeblinkDialog = _useModalQueryParam10[0],
    toggleWeblinkDialog = _useModalQueryParam10[1];
  var _useAddPlaylistAssets = useAddPlaylistAssets(playlist.id),
    addPlaylistAssets = _useAddPlaylistAssets.addPlaylistAssets,
    isAddingAssets = _useAddPlaylistAssets.isLoading;
  var onCloseAssetDialog = function onCloseAssetDialog() {
    toggleAssetDialog();
    if (hasNewContentDialog) {
      toggleNewContentDialog();
    }
  };
  var submitAssetPicker = function submitAssetPicker(_ref2) {
    var toAdd = _ref2.toAdd;
    var contentToAdd = toAdd.map(function (asset) {
      return {
        id: asset.id
      };
    });
    addPlaylistAssets({
      content: contentToAdd
    }, {
      onSuccess: function onSuccess() {
        onCloseAssetDialog();
      }
    });
  };

  // This function, being passed down to the itemPicker modal,
  // is used to update the playlistsToAdd state
  // in response to the user's selections there
  var onBeforeChange = function onBeforeChange(_ref3) {
    var toAdd = _ref3.toAdd,
      toRemove = _ref3.toRemove;
    setPlaylistsToAdd(function (prev) {
      if (toRemove.length > 0) {
        return prev.filter(function (playlist) {
          return playlist.id !== toRemove[0].id;
        });
      }
      return [].concat(_toConsumableArray(prev), [toAdd[0]]);
    });
  };
  var _useAddPlaylistLinks = useAddPlaylistLinks(playlist.id),
    addPlaylistLinks = _useAddPlaylistLinks.addPlaylistLinks,
    isAddingPlaylistLinks = _useAddPlaylistLinks.isLoading;
  var _getChildPlaylistPerm = getChildPlaylistPermissionStatus({
      playlistsToCheck: playlistsToAdd,
      audience: playlist.audience,
      teamIds: playlist.teamIds,
      currentPlaylistId: playlist.id
    }),
    restrictedPlaylists = _getChildPlaylistPerm.restrictedPlaylists,
    allowedPlaylists = _getChildPlaylistPerm.allowedPlaylists,
    hasRestrictedPlaylists = _getChildPlaylistPerm.hasRestrictedPlaylists,
    hasCircularPlaylists = _getChildPlaylistPerm.hasCircularPlaylists,
    circularReferencePlaylists = _getChildPlaylistPerm.circularReferencePlaylists;
  var addAllPlaylists = function addAllPlaylists(_ref4) {
    var _ref4$optional = _ref4.optional,
      optional = _ref4$optional === void 0 ? true : _ref4$optional;
    var circularContent = (circularReferencePlaylists === null || circularReferencePlaylists === void 0 ? void 0 : circularReferencePlaylists.map(function (playlist) {
      return {
        id: playlist.id,
        optional: true
      };
    })) || [];
    var restrictedContent = (restrictedPlaylists === null || restrictedPlaylists === void 0 ? void 0 : restrictedPlaylists.map(function (playlist) {
      return {
        id: playlist.id,
        optional: optional
      };
    })) || [];
    var allowedContent = (allowedPlaylists === null || allowedPlaylists === void 0 ? void 0 : allowedPlaylists.map(function (playlist) {
      return {
        id: playlist.id,
        optional: false
      };
    })) || [];
    var content = [].concat(_toConsumableArray(circularContent), _toConsumableArray(restrictedContent), _toConsumableArray(allowedContent));
    addPlaylistLinks({
      content: content
    }, {
      onSuccess: function onSuccess() {
        setShowOptionalModal(false);
        togglePlaylistLinkDialog();
        setPlaylistsToAdd([]);
      }
    });
  };
  var submitPlaylistPicker = function submitPlaylistPicker() {
    if (hasCircularPlaylists) {
      setShowCircularReferenceModal(true);
      return;
    }
    if (hasRestrictedPlaylists) {
      setShowOptionalModal(true);
      return;
    }
    addAllPlaylists({
      optional: false
    });
  };
  var submitNewLink = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(asset) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return addPlaylistAssets({
              content: [{
                id: asset.id
              }]
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function submitNewLink(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  function submitAssetEditor(_x2) {
    return _submitAssetEditor.apply(this, arguments);
  }
  function _submitAssetEditor() {
    _submitAssetEditor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref6) {
      var newContentId;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            newContentId = _ref6.newContentId;
            _context2.t0 = newContentId;
            if (!_context2.t0) {
              _context2.next = 5;
              break;
            }
            _context2.next = 5;
            return addPlaylistAssets({
              content: [{
                id: newContentId
              }]
            });
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _submitAssetEditor.apply(this, arguments);
  }
  var selectedPlaylists = [];
  (_playlist$content = playlist.content) === null || _playlist$content === void 0 ? void 0 : _playlist$content.forEach(function (content) {
    if (content.type === 'playlist') {
      selectedPlaylists.push(content);
    }
  });
  var showCreateAndAddAssetOptions = getIsAssetEditableInHub({
    ownerTeamId: playlist.ownerTeamId,
    domain_id: playlist.domain_id
  });
  var showCreateAssetOptions = getCanMembersContribute(playlist);
  var menuItems;
  if (showCreateAndAddAssetOptions) {
    menuItems = /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItemGroup, {
      label: t('content_type_existing')
    }, /*#__PURE__*/React.createElement(MenuItem, {
      icon: "asset-default",
      onClick: toggleAssetDialog
    }, t('content_type_asset')), /*#__PURE__*/React.createElement(MenuItem, {
      icon: "playlist-link",
      onClick: togglePlaylistLinkDialog
    }, t('content_type_playlist'))), /*#__PURE__*/React.createElement(MenuItemDivider, null), /*#__PURE__*/React.createElement(MenuItemGroup, {
      label: t('content_type_new')
    }, /*#__PURE__*/React.createElement(MenuItem, {
      icon: "upload",
      onClick: toggleNewContentDialog
    }, t('content_type_asset_from_file')), /*#__PURE__*/React.createElement(MenuItem, {
      icon: "link",
      onClick: toggleWeblinkDialog
    }, t('file_type_web')), /*#__PURE__*/React.createElement(MenuItem, {
      icon: "section",
      onClick: toggleSectionDialog
    }, t('file_type_section'))));
  } else if (showCreateAssetOptions) {
    menuItems = /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
      icon: "upload",
      onClick: toggleNewContentDialog
    }, t('content_type_asset_from_file')), /*#__PURE__*/React.createElement(MenuItem, {
      icon: "link",
      onClick: toggleWeblinkDialog
    }, t('file_type_web')));
  } else {
    menuItems = /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
      icon: "asset-default",
      onClick: toggleAssetDialog
    }, t('content_type_asset')), /*#__PURE__*/React.createElement(MenuItem, {
      icon: "section",
      onClick: toggleSectionDialog
    }, t('content_type_section')), /*#__PURE__*/React.createElement(MenuItem, {
      icon: "playlist-link",
      onClick: togglePlaylistLinkDialog
    }, t('content_type_playlist')));
  }
  return /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(MenuButton, {
    variant: "transparent",
    size: "small",
    icon: "plus",
    iconRight: "chevron"
  }, t('actions_add_content')), menuItems, hasAssetPicker && /*#__PURE__*/React.createElement(AssetPickerModal, {
    owner: "local_and_common",
    isDisabled: isAddingAssets,
    disabledItems: playlist.content,
    privilege: ASSET_READ,
    onClose: onCloseAssetDialog,
    onSubmit: submitAssetPicker
  }), hasPlaylistLinkDialog && /*#__PURE__*/React.createElement(PlaylistPickerModal, {
    isDisabled: isAddingPlaylistLinks,
    disabledItems: selectedPlaylists,
    filterItems: function filterItems(_ref7) {
      var id = _ref7.id;
      return id !== playlist.id;
    },
    onClose: function onClose() {
      togglePlaylistLinkDialog();
      setPlaylistsToAdd([]);
    },
    onSubmit: submitPlaylistPicker,
    onBeforeChange: onBeforeChange,
    parentPlaylistId: parentPlaylistId
  }), hasSectionDialog && /*#__PURE__*/React.createElement(SectionEditorModal, {
    playlistId: playlist.id,
    onClose: toggleSectionDialog
  }), hasWeblinkDialog && /*#__PURE__*/React.createElement(NewLinkModal, {
    parentPlaylist: playlist,
    onClose: toggleWeblinkDialog,
    onSubmit: submitNewLink
  }), hasNewContentDialog && /*#__PURE__*/React.createElement(AssetEditor, {
    parentPlaylist: playlist,
    onSubmit: submitAssetEditor,
    onClose: toggleNewContentDialog,
    onSelectAsset: toggleAssetDialog
  }), showCircularReferenceModal && /*#__PURE__*/React.createElement(CircularReferenceInfoModal, {
    circularPlaylists: (circularReferencePlaylists === null || circularReferencePlaylists === void 0 ? void 0 : circularReferencePlaylists.map(function (item) {
      return item.name;
    })) || [],
    onCloseModal: function onCloseModal() {
      setShowCircularReferenceModal(false);
    },
    onSubmit: function onSubmit() {
      setShowCircularReferenceModal(false);
      if (hasRestrictedPlaylists) {
        setShowOptionalModal(true);
        return;
      }
      addAllPlaylists({
        optional: true
      });
    }
  }), showOptionalModal && /*#__PURE__*/React.createElement(PlaylistLinkPermissionModal, {
    onClose: function onClose() {
      setShowOptionalModal(false);
    },
    onSubmit: addAllPlaylists,
    playlistNames: (restrictedPlaylists === null || restrictedPlaylists === void 0 ? void 0 : restrictedPlaylists.map(function (playlist) {
      return playlist.name;
    })) || []
  }));
}
export default AddContentMenu;